export function WarningData(lastSevenDays) {
  let dataDom = [
    {
      "data": [],
      "name": "步距预警",
      "type": 1
    },
    {
      "data": [],
      "name": "人员预警",
      "type": 2
    },
    {
      "data": [],
      "name": "车辆预警",
      "type": 3
    },
    {
      "data": [],
      "name": "气体预警",
      "type": 4
    }
  ];

  lastSevenDays.forEach(itemDate => {
    dataDom[0].data.push({
      date: itemDate.startTime,
      count: Math.random()
    })
  })

  lastSevenDays.forEach(itemDate => {
    dataDom[1].data.push({
      date: itemDate.startTime,
      count: Math.random()
    })
  })

  lastSevenDays.forEach(itemDate => {
    dataDom[2].data.push({
      date: itemDate.startTime,
      count: Math.random()
    })
  })

  lastSevenDays.forEach(itemDate => {
    dataDom[3].data.push({
      date: itemDate.startTime,
      count: Math.random()
    })
  })

  return dataDom;

}